import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SttList } from './SttList';
import { SelectGroupPopup } from '../all';

type Group = {
    id: number;
    name: string;
};

type Props = {
    groups: Group[];
    onAdd: (group: Group) => void;
    onDelete?: (group: Group) => void;
};

export function SttGroupList({
    groups,
    onAdd,
    onDelete,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    const [selectionOpen, setSelectionOpen] = useState(false);

    function openAddTerrain() {
        setSelectionOpen(true);
    }

    function selectGroup(group: Group) {
        setSelectionOpen(false);
        if (!groups.find((g: any) => g.id === group.id)) {
            onAdd(group);
        }
    }

    return (
        <>
            <SttList
                title={t('labels.groups')}
                onAdd={openAddTerrain}
                onDelete={onDelete}
                data={groups?.map((group: any) => ({
                    caption: group.name,
                    objToSelect: group,
                }))}
            />

            {selectionOpen && (
                <SelectGroupPopup
                    open
                    noPagination
                    onClose={() => setSelectionOpen(false)}
                    onSelect={(group: any) => selectGroup(group)}
                />
            )}
        </>
    );
}
